import { APP_BASE_HREF, DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { ManualInboundCallAlertState, HeaderService } from '@app/_core/services/header.service';
import { DialerService } from '@app/_core/services/dialer.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { TmQueueService } from '@app/_core/services/tm-queue.service';
import { UserService } from '@app/_core/services/user.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { EditAvatarComponent } from '@app/pages/common/edit-avatar/edit-avatar.component';
import { UsermenuvoicemailsComponent } from '@app/pages/console/usermenuvoicemail/usermenuvoicemails/usermenuvoicemails.component';
import { CurrentStatusMessageComponent } from '@app/pages/dashboard/current-status-message/current-status-message.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { PhoneSettingsComponent } from '@app/pages/common/phone-settings/phone-settings.component';
import { ProfileInfoService } from 'src/app/_core/services/profile-info.service';
import { SwitchClientComponent } from '../switch-client/switch-client.component';
import { LoaderService } from '@app/_core/services/loader.service';
import { HubService } from '@app/pages/hubs/common/HubService';
import { MainControllerComponent } from 'src/app/pages/queue/dialer/MainController.component';
import { Subject, Subscription } from 'rxjs';
import { exhaustMap } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  IncomingCallAlerttext: any = '';
  countdownField: any = '';
  modalRef?: BsModalRef;
  appBaseUrl: any;
  IsDisableHeader: boolean = false;
  isSoftphoneOnly = false;
  VoiceMailCount: number = 0;
  isConferenceWindowOpen: boolean = false;
  voiceCountInterval: any;
  basicAgentuserCountInterval: any;
  inboundQueueInterval: any;
  private basicAgentStatsTrigger$ = new Subject<void>();
  private basicAgentStatsSub: Subscription;
  private voiceMailCountTrigger$ = new Subject<void>();
  private voiceMailCountSub: Subscription;
  accessibleClients: any;
  display: string = 'none';
  selectedClient: any = {};
  showHideCallDialer: boolean = false;
  //ReadOnly: boolean;
  IsManualInboundCallAlert: boolean = false;
  CoundDown: string = '';
  newCallSnd = new Audio('https://common.cts-connect.com/Audio/ding-ding.ogg');
  ShowManualInboundcallAlert: boolean = false;
  callAlertInterval: any = null;
  ActionItemID: any = '';
  conference: any;
  isBlendedManual: boolean = false;
  QueueSegmentId: number = -1;
    Iscallanswered: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tmqueueService: TmQueueService,
    private modalService: BsModalService,
    private appService: AppService,
    private DialerService: DialerService,
    private headerService: HeaderService,
    private userService: UserService,
    private securityService: SecurityService,
    private managerService: ManagerService,
    private auditService: AuditorService,
    private queueServices: QueuesService,
    private utils: Utils,
    private ProfileInfo: ProfileInfoService,
    private hubService: HubService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(APP_BASE_HREF) public baseHref: string,
    public queueService: QueuesService,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService,
    private mainController: MainControllerComponent
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
    //console.log('appBaseUrl', this.appBaseUrl);
    this.hubService.InboundCallEvents.subscribe((value: any) => {
      if (value && (value.eventName == 'OUTBOUND_CALL' || value.eventName == 'INBOUND_CALL')) {//&& !this.mainController.getisCaseDetailStatus()
        //console.log('outbound inbound call received', value.data);
        // _userDetails = value.data;
        this.eInboundCallHandler(value.data);
      } else if (value && value.eventName == 'CALL_Ended') {
          // _userDetails = value.data;
          clearInterval(this.callAlertInterval);
          this.ShowManualInboundcallAlert = false;
      }
    });
  }
  ngOnDestroy(): void {
    if (this.voiceCountInterval) {
      clearInterval(this.voiceCountInterval);
    }
    if (this.inboundQueueInterval) {
      clearInterval(this.inboundQueueInterval);
    }
    if (this.basicAgentuserCountInterval) {
      clearInterval(this.basicAgentuserCountInterval);
    }
    if (this.callAlertInterval) {
      clearInterval(this.callAlertInterval);
    }
    if (this.basicAgentStatsSub) {
      this.basicAgentStatsSub.unsubscribe();
    }
    this.basicAgentStatsTrigger$.complete();
    if (this.voiceMailCountSub) {
      this.voiceMailCountSub.unsubscribe();
    }
    this.voiceMailCountTrigger$.complete();
  }

  @Input() status: any;
  user: any;
  menu: any;
  queueType: any;
  minutes: any;
  seconds: any;
  stats: any = {
    Inbound: [
      { text: 'User in Queue', data: 0 },
      { text: 'Max Wait Time', data: 0 },
    ],
    Console: [
      { text: '', data: 0 },
      { text: '', data: 0 },
    ],
    Others: [
      { text: 'Calls Today', data: 0 },
      { text: 'AHT Today', data: 0 },
    ],
  };
  inboundmenuname: any;
  inboundQueueId: any;
  @Input() URL: string;
  userMenuItems: any = {};
  pod = this.appService.getPod();
  tld = this.appService.getEnvironmentTLD();
  applinks: any = [
    { text: 'Switch Client', action: () => this.switchClient(), grant: 'GlobalAccess' },
    // {
    //   text: "Telemarketing", url: "https://tm" + (this.pod == "1" ? "" : this.pod) + ".q-central" + (this.tld != "stage" ? "." + this.tld : "stage.com"), grant: "TM", icon: "https://47cb4c0c4e265394b582-106204d7114cedbc4982d4dca06d66ac.ssl.cf2.rackcdn.com/icon_16_switch.png", lineBreak: true
    // },
    // { text: "Admin", url: "https://admin" + (this.pod == "1" ? "" : this.pod) + ".q-central" + (this.tld != "stage" ? "." + this.tld : "stage.com"), grant: "Admin" },
    // { text: "Reporting", url: "https://dashboard" + (this.pod == "1" ? "" : this.pod) + ".q-central" + (this.tld != "stage" ? "." + this.tld : "stage.com"), grant: "Reporting" }

    { text: 'Admin', action: () => this.goToAdmin(), grant: 'Admin' },
    { text: 'Reporting', action: () => this.goToDashboard(), grant: 'Reporting' },
    /*{text:"JIRA", icon:im.CDNImages.icon_14_jira_png, url:"http://qbridge.jira.com", role:"GlobalUser"},
      {text:"Team Site", icon:im.CDNImages.icon_14_q_png, url:"http://team.qbridge.com", role:"GlobalUser"}];*/
  ];
  // url:  window.open('https://admin.stage.cts-connect.com/'),
  // url:  window.open('https://dashboard.stage.cts-connect.com/'), 
  _qbr_linkArray: any = [];
  defaultLinks: any = [
    {
      text: 'Edit Avatar',
      icon: this.baseHref + '/assets/images/user-icon-menu/icon-avatar.svg',
      action: () => this.editAvatar(),
      display: true
    },
    {
      text: 'Log Out',
      icon: this.baseHref + '/assets/images/user-icon-menu/icon-logout.svg',
      action: () => this.logout(),
      display: true
    },
  ];

  //  //if(this.getAgentStatus() != '5' && this.getAgentStatus() != '7' && this.getAgentStatus() != '8') { }
  //userMenuItems = [
  //  {
  //    text: 'Voicemails',
  //    icon: this.baseHref + '/assets/images/user-icon-menu/icon-voicemail.svg',
  //    action: () => this.showVoicemails(),
  //  },
  //  {
  //    text: 'Change Status',
  //    icon: this.baseHref + '/assets/images/user-icon-menu/icon-change-status.svg',
  //    action: () => this.setStatusAway(),
  //  },
  //  {
  //    text: 'Phone Settings',
  //    icon: this.baseHref + '/assets/images/user-icon-menu/icon-phone-settings.svg',
  //    action: () => this.editPhoneNumber(),
  //  },
  //];
  cols: any = [
    { name: 'User', label: 'User', showFilter: true },
    { name: 'UserPhoneNumber', label: 'User Phone', showFilter: true },
    { name: 'InboundPhoneNumber', label: 'Inbound Phone', showFilter: true },
    { name: 'Queue', label: 'Queue', showFilter: true },
    { name: 'RequestType', label: 'Request Type' },
    { name: 'Status', label: 'Status', showFilter: true, sortable: false },
    { name: 'Created', label: 'Received', type: 'date' },
  ];
  showAppSwitchDropdown: boolean = false;
  showUserMenuDropdown: boolean = false;

    ngOnInit() {
        
    this.loadUserMenuItems();
    this.resetAlert();
    this.appService.updatedImageURL.subscribe(value => {
      this.URL = value ? value : this.baseHref + '/assets/images/user-icon-menu/avatar-default.png';
    });

    //this.headerService.countdownField$.subscribe(
    //  (value) => {
    //    this.CoundDown = value;
    //});

    //this.headerService.manualInboundCallAlert$.subscribe(
    //  (state: ManualInboundCallAlertState) => {
    //    this.IsManualInboundCallAlert = state?.show;
    //    this.IncomingCallAlerttext = state?.incomingCallAlertText || '';
    //  }
    //);

    const linkCount = 0;
    for (let i = 0, l = this.applinks.length; i < l; i++) {
      let isValid = true;
      if (this.applinks[i].grant) isValid = this.securityService.validateGrant(this.applinks[i].grant);
      if (isValid && this.applinks[i].role) {
        isValid = this.securityService.validateRole(this.applinks[i].role);
      }
      this.applinks[i].valid = isValid;
      const url = this.applinks[i].url,
        action = this.applinks[i].action,
        urlBuilder = this.applinks[i].urlBuilder,
        isOnURL = document.location.href.indexOf(url) === 0;
    }
    //this.userService.getUser(false, '').subscribe(data => {
    // this.user = data.Response.User;
    //});
    this.GetUserFullName();
    this.getAvatar();
      this.basicAgentStatsSub = this.basicAgentStatsTrigger$.pipe(
        exhaustMap(() => this.userService.getBasicAgentStats())
      ).subscribe(res => {
        if (res.Response.Status != 2) {
          this.stats.Others[0].data = res.Response.Data.Calls;
          this.stats.Others[1].data = this.utils.formatDuration(res.Response.Data.AHT, 's', false, false, false);
        }
      });
      this.basicAgentuserCountInterval= setInterval(() => {
      this.getBasicAgentStats();
    }, 20000)
      // exhaustMap drops this tick if the previous GetVoicemailCountByStatus call is still in flight
      this.voiceMailCountSub = this.voiceMailCountTrigger$.pipe(
        exhaustMap(() => this.managerService.GetVoicemailCountByStatus('New', -1))
      ).subscribe(res => {
        this.VoiceMailCount = res['Response']['Data'] ? res['Response']['Data'] : 0;
        this.managerService.setVoiceMailCount(this.VoiceMailCount);
      });
    //this.getBasicAgentStats();
    //console.log(this.user);

    this.appService.selectedQueueName.subscribe((data: any) => {
      this.menu = data;
    });
    // this.queueServices.currentQueue.subscribe((data: any) => {
    //   this.menu = data;
    // });
    this.appService.selectedQueueId.subscribe((data: any) => {
      this.inboundQueueId = data;
    });
    this.appService.selectedQueueType.subscribe((data: any) => {
      this.queueType = data;
    });
    if ((this.menu = 'Manager Console')) {
      this.getUserStats();
    }
    // this.DialerService.setUserStatus('Queue Selection Ready');
    this.setClientWebSiteLink();
    this.setMenuLinks([], true);
    this.queueService.notifyObservable$.subscribe(res => {
      if (res.refresh) {
        this.inboundmenuname = res.menuName;
        //this.getInboundCallStats();
      }
    });
    this.changeUserStatusHeader();
    this.queueService.DisableControls.subscribe(res => {
      this.IsDisableHeader = res;
    });

    this.GetVoiceMailCount();
    this.getInbountQueueStats();
    this.DialerService.userStatus.subscribe((status: any) => {
      if (status) {
        if (this.status != status) {
          this.changeUserStatusHeader();
          this.status = status;
          this.showHideMenuItems()
        }
      }
    });
    // this.DialerService.isCaseLocked.subscribe((res) => {
    //   // if (res) {
    //   //console.log(res,'lock res');
    //   this.ReadOnly = res
    //   // }
    // });



  }



  showHideMenuItems() {
    if (this.getAgentStatus() == 5 || this.getAgentStatus() == 7 || this.getAgentStatus() == 8) {
      this._qbr_linkArray = this._qbr_linkArray.map(item =>
        item.text === 'Change Status' ? { ...item, display: false } : item
      )
    }
    else {
      this._qbr_linkArray = this._qbr_linkArray.map(item =>
        item = { ...item, display: true }
      )
    }
  }
  loadUserMenuItems() {
    this.userMenuItems = [
      {
        text: 'Voicemails',
        icon: this.baseHref + '/assets/images/user-icon-menu/icon-voicemail.svg',
        action: () => this.showVoicemails(),
        display: true
      },
      {
        text: 'Change Status',
        icon: this.baseHref + '/assets/images/user-icon-menu/icon-change-status.svg',
        action: () => this.setStatusAway(),
        display: true
      },
      {
        text: 'Phone Settings',
        icon: this.baseHref + '/assets/images/user-icon-menu/icon-phone-settings.svg',
        action: () => this.editPhoneNumber(),
        display: true
      },
    ];
  }
  getInbountQueueStats() {
    this.inboundQueueInterval = setInterval(() => {
      let url = this.queueService.getQueueRoute();
      if (url.toLowerCase().includes('inbound') && url.toLowerCase().includes('qid')) {
        let qid = url.split('?')[1].split('=')[1];
        this.getInboundCallStats(qid);
      }
    }, 10000);
  }
  GetUserFullName() {
    let CurUser = this.webStorageService.getItemFromSessionStorage('currentUser');
    if (CurUser) {
      let UserName = '';
      if (CurUser.LastName != null && CurUser.LastName != '')
        UserName = CurUser.LastName.slice(0, 1) + '.';
      UserName = this.toPascalCase(UserName) + this.toPascalCase(CurUser.FirstName);
      this.user = UserName;
    }
  }
  toPascalCase = str => {
    let tempArray = str.split(' ');
    tempArray = tempArray.map(value => value.charAt(0).toUpperCase() + value.slice(1, value.length));
    return tempArray.join(' ');
  };
  setMenuLinks(customLinks: any, initial: any) {
    let newLinkArray: any = [];
    if (customLinks) {
      newLinkArray = newLinkArray.concat(customLinks);
    }
    newLinkArray = newLinkArray.concat(this.defaultLinks);
    if (this.linksChanged(newLinkArray)) {
      this._qbr_linkArray = newLinkArray;
      /*  if (initial)
            cls.Super();
        else
            cls.drawLinks();*/
    }
  }

  linksChanged(newLinkArray: any) {
    if (newLinkArray.length != this._qbr_linkArray.length) return true;
    for (let i = 0; i < newLinkArray.length; i++) {
      if (newLinkArray[i].text != this._qbr_linkArray[i].text) return true;
      if (newLinkArray[i].icon != this._qbr_linkArray[i].icon) return true;
      if (newLinkArray[i].action != this._qbr_linkArray[i].action) return true;
      if (newLinkArray[i].display != this._qbr_linkArray[i].display) return true;
    }
    return false;
  }

  openAppSwitchMenu() {
    this.showAppSwitchDropdown = !this.showAppSwitchDropdown;
  }

  openUserMenu() {
    this.showUserMenuDropdown = !this.showUserMenuDropdown;
  }
  menuAction(link: any) {
    link.action();
    this.showUserMenuDropdown = !this.showUserMenuDropdown;
  }

  logoAction(link: any) {
    link.action();
    this.showAppSwitchDropdown = !this.showAppSwitchDropdown;
  }

  setClientWebSiteLink() {
    const ClientAttrs = this.webStorageService.getItemFromSessionStorage('ClientAttrs');
    //if (!this.appService.getClientAppParams().noClient) {
    // if (this.appService.clientAppParams.BaseURL) {
    const text = 'Visit Web Site';
    const icon = this.baseHref + '/assets/images/user-icon-menu/icon-website.svg';
    // const icon = ''; //(this.appService.clientAppParams.clientAttrs().Icon) ? this.appService.clientAppParams.clientAttrs().Icon : '';
    const clientWebSiteLink = [
      {
        text: text,
        icon: icon,
        action: () => {
          window.open('http://' + ClientAttrs.BaseURL, '_blank');
        },
        display: true
      },
    ];
    this.defaultLinks = clientWebSiteLink.concat(this.defaultLinks);
    this.defaultLinks = this.userMenuItems.concat(this.defaultLinks);
    //  }
    //}
  }

  changeUserStatus() {
    const newStatus = this.DialerService.getUserStatus();
    if (newStatus != undefined)
      if (this.status != newStatus) {
        this.changeUserStatusHeader();
        this.status = newStatus;
      }
    return newStatus;
  }

  changeUserStatusHeader() {
    //logic to execute only when change in status happened.
    const menuName = this.appService.getCurrentMenu().value;
    const menu = menuName?.listmenu;
    //console.log(menu?.split('/')[1] + 'listmanume' + menuName?.listmenu);
    if (menu?.split('/')[1] === 'Console') {
      //this.DialerService.setUserStatus('On Console (Ready)');
      if (this.queueServices.GetVoicemailDetailsReply()) {
        this.DialerService.setDialerPadVisible(true);
      }
      else {
        this.DialerService.setDialerPadVisible(false);
      }
    } else if (menu?.split('/')[1] === 'Performance') {
      // this.DialerService.setUserStatus('On Dashboard (Ready)');

    } else if (
      menu?.split('/')[1] === 'Queue' &&
      (menuName?.menu === 'Inbound' || menuName?.menu === 'Outbound' || menuName?.menu === 'Search')
    ) {
      this.DialerService.setDialerPadVisible(true);
    } else {
      // this.DialerService.setDialerPadVisible(false);
      if (this.queueServices.GetVoicemailDetailsReply()) {
        this.DialerService.setDialerPadVisible(true);
      }
      else {
        this.DialerService.setDialerPadVisible(false);
      }
    }
  }

  logout() {
    this.loaderService.setOnDemandLoading(true);
    this.tmqueueService.setUserStatus(2, null).subscribe((result: any) => {
      this.appService.setCurrentMenu(null);
      Utils.store('clientAbbreviation', null);
      this.securityService.clientAbbr = null;
      this.securityService.setUserData(null);
      this.loaderService.display(false);
      this.userService.logout();
    });
  }
  //appSwitcher
  //currentQueue
  //currentUser

  //menuItems

  showVoicemails() {
    //const config: ModalOptions = { class: 'modal-xl' };
    const config: ModalOptions = {
      class: 'modal-xl',
      backdrop: 'static',
      keyboard: false

    };
    this.modalRef = this.modalService.show(UsermenuvoicemailsComponent, config);
    //this.modalRef.content.event.subscribe((result: any) => {});
  }

  setStatusAway() {
    // var isBlendedAvailable = this.tmqueueService.getisBlendedQueueAvailable();
    //this.queueService.setTaskMenuAccordian('Inbound');
    //  this.queueService.setTaskMenuAccordian((isBlendedAvailable ? 'Blended' : 'Inbound'));
    if (this.DialerService.getIsStatusModalOpen()) {
      return;
    }
    const config: ModalOptions = {
      class: 'modal-sm',
      backdrop: 'static',
      keyboard: false
    };
    this.DialerService.setIsAgentStatusChangeRequired(true);
    this.modalRef = this.modalService.show(CurrentStatusMessageComponent, config);
    //this.modalRef?.content?.event.subscribe((result: any) => { });

  }
  switchClient() {
    this.accessibleClients = this.webStorageService.getItemFromSessionStorage('AccessibleClients');
    //console.log(this.accessibleClients,'accessibleClients')
    if (this.accessibleClients && this.accessibleClients.length > 0) {
      this.showAppSwitchDropdown = !this.showAppSwitchDropdown;
      const initialState = {
        accessibleClients: this.accessibleClients,
        voiceCountInterval: this.voiceCountInterval,

      };
      const config: ModalOptions = {
        class: 'modal-sm',
        backdrop: 'static',
        keyboard: false,
        initialState
      };

      this.modalRef = this.modalService.show(SwitchClientComponent, config);
      // this.modalRef.content.event.subscribe((result: any) => { });

      // this.openModal();
    }
  }

  goToDashboard() {
    let url = this.webStorageService.getItemFromSessionStorage('DashboardUrl');
    window.open(this.GetUrl(url));
    //window.open('https://dashboard.stage.cts-connect.com/');
  }

  goToAdmin() {
    let url = this.webStorageService.getItemFromSessionStorage('AdminUrl');
    window.open(this.GetUrl(url));
    //window.open('https://admin.stage.cts-connect.com/');
  }
  GetUrl(url: any) {
    if (url.includes('webapi')) {
      return url = 'https://' + url.split('/')[0].toLowerCase() + '/';
    } else {
      return url = 'https://' + url.toLowerCase() + '/';
    }
  }

  HideShowDialer() {
    return this.DialerService.isDialerPadVisible() //&& this.DialerService.getEnableFreeDialer();
  }

  editAvatar() {
    const config: ModalOptions = {};

    this.modalRef = this.modalService.show(EditAvatarComponent, config);
    //this.modalRef.content.event.subscribe((result: any) => {});
  }

  getAvatar() {
    //alert('inside get avatar')
    this.userService.getAvatar().subscribe(async response => {
      //console.log('getAvatar', response.Response.Data);
      const txtURL = response.Response.Data;
      if (txtURL !== null && txtURL !== undefined) {
        this.getImage(response.Response.Data);
      }
      // else {
      //   this.URL = this.baseHref + '/assets/images/user-icon-menu/avatar-default.png';
      // }
    });
  }

  getImage(file: any) {
    this.managerService.getRecordingFiles(file).subscribe(data => {
      //console.log('getImageAvatar', data);
      this.URL = 'data:' + data.MimeType + ';base64,' + data.result;
      this.appService.setupdatedImageURL(this.URL);
    });
  }

    getBasicAgentStats() {
        if (!this.appService.getUserLoggedout()) {
            // exhaustMap on the trigger subject drops this tick if the previous call is still in flight
            this.basicAgentStatsTrigger$.next();
        }
        else {
            this.clearAllTimers();
        }
  }

  getInboundCallStats(selectedQueueID: any) {
    //  console.log(selectedQueueID + 'selectedQueueID');
    this.userService.getInboundCallStats(selectedQueueID).subscribe(res => {
      this.stats.Inbound[0].data = res.Response.Data.QueueLength;
      this.stats.Inbound[1].data = this.utils.formatDuration(res.Response.Data.MaxWaitTime, 's', false, false, false); //res.Response.Data.MaxWaitTime;
      // console.log(res.Response.Data.QueueLength + 'stats inbound' + res.Response.Data.MaxWaitTime);
    });
  }

  getUserStats() {
    this.auditService.getUserStats().subscribe(res => {
      if (res.Response.Data.Role.Name === 'Auditor') {
        this.menu = 'Auditor Console';
      }
      switch (res.Response.Data.Role.Name) {
        case 'Manager':
          this.stats.Console[0].text = 'Average Audit Score';
          this.stats.Console[0].data = res.Response.Data.AvgScore;
          this.stats.Console[1].text = 'Low / High Scores';
          this.stats.Console[1].data = res.Response.Data.MinScore + ' / ' + res.Response.Data.MaxScore;
          break;
        case 'Auditor':
          this.stats.Console[0].text = 'Audits In Progress';
          this.stats.Console[0].data = res.Response.Data.AuditsInProgress;
          this.stats.Console[1].text = 'Audits Submitted Today';
          this.stats.Console[1].data = res.Response.Data.AuditsSubmittedToday;
          break;
        default:
          this.stats.Console[0].text = 'Total Agents';
          this.stats.Console[0].data = res.Response.Data.TotalAgents;
          this.stats.Console[1].text = 'Total Audits Completed Today';
          this.stats.Console[1].data = res.Response.Data.TotalAuditsCompletedToday;
          break;
      }
    });
  }
  editPhoneNumber() {
    const config: ModalOptions = { class: 'modal-sm' };
    this.modalRef = this.modalService.show(PhoneSettingsComponent, config);
    //this.modalRef.content.event.subscribe((result: any) => {});
  }

    GetVoiceMailCountByUser() {
        if (!this.appService.getUserLoggedout()) {
            this.voiceMailCountTrigger$.next();
            this.appService.ChecklastgetuserCalled();
        }
        else {
            this.clearAllTimers();
        }
  }
  GetVoiceMailCount() {
    this.voiceCountInterval = setInterval(() => {
      this.GetVoiceMailCountByUser();
    }, 15000);
  }
    clearAllTimers(): void {
        clearInterval(this.voiceCountInterval);
        clearInterval(this.basicAgentuserCountInterval);
    }
  getCallTransferStatus() {
    //  return '{dialer-index:'+ this.DialerService.getisCallTransferstarted()+'}';
    return this.DialerService.getisCallTransferstarted();
  }
  conferenceWindowStatus(event) {
    this.isConferenceWindowOpen = event;
  }

  getAgentStatus() {
    return this.ProfileInfo.getAgentStatus();
  }
  CallDialerVisibility(event) {
    this.showHideCallDialer = event
  }
  checkDialerVisibility() {
    return this.showHideCallDialer && this.DialerService.isDialerPadVisible()
  }

  inboundCallAlert = function (callDetails) {

    if (!this.mainController.postCall) {
      this.mainController.callEnded_phnctrl();
    }
      this.ShowManualInboundcallAlert = true;
      //this.Iscallanswered = false;
      this.mainController.setistransferedcallanswered(false);
    let Number = callDetails.find(i => i.key === 'number').value,
      name = Utils.cleanString(callDetails.find(i => i.key === 'name').value),
      queue = Utils.cleanString(callDetails.find(i => i.key === 'queue').value),
      _callId = callDetails.find(i => i.key === 'callID').value,
      queuedTime = this.convertServerDate(callDetails.find(i => i.key === 'queuedTime').value),
      //now = this.convertServerDate(callDetails.find(i => i.key === 'CurrentTime').value),
      now = 0,
      secondsRemaining = Math.floor(Math.min(60, 90 - (now - queuedTime) / 1000)),
      conference = callDetails.find(i => i.key === 'conference').value;

    this.callId = _callId;
    this.queueServices.setCallID(_callId);
    //console.log('CallTransfer issue, rcvd callid:', _callId);
    console.log('Outbound inboundCallAlert CALLID:' + this.queueServices.getCallID());
    this.newCallSnd.play();
    if (!conference) {
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      // btnView.addSubView(countdownField);
    }

    this.IncomingCallAlerttext =
      'Incoming ' +
      (conference ? 'conference with ' : 'call from ') +
      (Number == null ? '' : Number) +
      (name && name != '' ? ' - ' + name : '') +
      (queue && queue != '' ? ' (' + queue + ')' : '') +
      (this.postCall ? ' - Finish the current call to answer.' : '');
    //notification = cls.showNotification({
    //    text: text,
    //    bgColor: conference || postCall ? '#89EBE1' : '#FBF301',
    //    view: postCall ? null : btnView,
    //    timeout: false,
    //    clickToClose: false
    //});
    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    this.callAlertInterval = setInterval(() => {
      secondsRemaining--;
      this.countdownField = '00:' + (secondsRemaining < 10 ? '0' : '') + secondsRemaining;
      if (secondsRemaining == 0) {
        // notification.close();
      //  clearInterval(this.callAlertInterval);
          this.ShowManualInboundcallAlert = false;
          //if (!this.Iscallanswered)
          //  this.rejectInboundCall(this.queueServices.getCallID());
        // im.InteractionService.instance().RejectCall({ callID: call.CallID };
        }
      else if (secondsRemaining < -2) {
          console.log('Auto Reject call in:', secondsRemaining + ',Iscallanswered:' + this.mainController.getistransferedcallanswered()) ;
            // notification.close();
            clearInterval(this.callAlertInterval);
            this.ShowManualInboundcallAlert = false;
          if (!this.mainController.getistransferedcallanswered()) {
              console.log('Reject Call Triggered');
              this.rejectInboundCall(this.queueServices.getCallID());

          }
            // im.InteractionService.instance().RejectCall({ callID: call.CallID };
        }
    }, 1000);
  };

  convertServerDate = function (date) {
    if (!date) return null;
    const dateFormat = /\/Date\(.*\)\//gi;
    if (dateFormat.test(date)) return new Date(parseInt(date.replace('/Date(', '').replace(')/', '')));
    else return new Date(date);
  };

  eInboundCallHandler = function (callDetails) {
    this.inboundCallAlert(callDetails);
  };
    answerCall() {
        clearInterval(this.callAlertInterval);
        this.DialerService.setIsFreeDialer(false);
        this.mainController.setistransferedcallanswered(true);
        console.log('answered call:', this.mainController.getistransferedcallanswered() );
    this.resetAlert();
    console.log('answer accept:', this.queueServices.getCallID());
    //this.headerService.triggerAnswerInboundCall(true);
    this.releaseCurrentLocks();
    


  }
  releaseCurrentLocks () {
      this.tmqueueService.releaseLocks().subscribe(res => {
          this.answerInboundNextCall();
      }
      );
  }
  rejectCall() {
    this.resetAlert();
    // this.headerService.triggerRejectInboundCall(true);
    this.rejectInboundCall(this.queueServices.getCallID());
  }

  getCallAlertStatus() {
    return this.ShowManualInboundcallAlert;
  }

  resetAlert() {
    this.ShowManualInboundcallAlert = false;
    this.IncomingCallAlerttext = '';
    this.countdownField = '';
  }
  getNextCallDetails() {

  }
  answerInboundNextCall() {


    if (this.callAlertInterval) clearInterval(this.callAlertInterval);
    //if (this.ActionItemID === '') {

    //    this.getNextCallDetails();
    //}
    this.ActionItemID = this.queueServices.getselectedQueueId() + (this.conference ? '-conference_' : '-inbound_') + this.queueServices.getCallID();
    const data: any = {};
    data.dialerType = this.mainController.queueDialerType;
    data.navigateURL = this.ActionItemID;
    data.interactionType = this.mainController.QueueInteractionType;
    this.mainController.CallCurrentActionItems(this.queueServices.getselectedQueueId(), data);

  }

  rejectInboundCall(_callId) {
    this.tmqueueService.rejectCall(_callId).subscribe(data => {
      //console.log("isInboundCallConnected response", data);
    });
    this.DialerService.setIsTransferCallRejected(true);
  }
}
